"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushClientEvent = void 0;
const push_event_1 = require("../push-event");
const session_id_1 = require("./session-id");
const subscription_1 = require("../utilities/subscription");
const utm_tags_1 = require("./utm-tags");
const getDomain = () => {
    const url = window.location.origin;
    const index = url.indexOf("kvix");
    const domain = url.substring(index, url.length);
    return "https://" + domain;
};
const DOMAIN_URL = process.env.NODE_ENV === "development"
    ? "http://localhost:1338/"
    : getDomain() + "/api/event-catcher/";
const bakeClientData = (clientData) => {
    var _a, _b, _c, _d, _e;
    const pushData = {
        sessionId: (0, session_id_1.getOrSetSessionId)(),
        userId: (_b = (_a = clientData.user) === null || _a === void 0 ? void 0 : _a.id.toString()) !== null && _b !== void 0 ? _b : "-1",
        pathFrom: (_c = clientData.pathFrom) !== null && _c !== void 0 ? _c : window.location.href,
        pathTo: (_d = clientData.pathTo) !== null && _d !== void 0 ? _d : window.location.href,
        source: clientData.source,
        userAgent: navigator.userAgent,
        featureType: clientData.featureType,
        subscriptionType: (0, subscription_1.getSubscriptionType)((_e = clientData.user) === null || _e === void 0 ? void 0 : _e.stripeProducts),
        firebaseId: clientData.firebaseId,
        utmTags: (0, utm_tags_1.getUtmTags)()
    };
    return pushData;
};
const pushClientEvent = (clientData) => {
    const pushData = bakeClientData(clientData);
    (0, push_event_1.pushEvent)(DOMAIN_URL + "events", pushData);
};
exports.pushClientEvent = pushClientEvent;
//# sourceMappingURL=index.js.map